<h3 class="mt-4 text-center text-[1.75rem] font-semibold">{{ 'chat.emptyThread.headline' | transloco }}</h3>
<p class="mt-8 text-center leading-relaxed xl:leading-loose">{{ 'chat.emptyThread.subline' | transloco }}</p>

<div class="mt-8 grid grid-cols-2 gap-4 md:mt-12 md:grid-cols-3 xl:gap-6">
  @for (num of [1, 2, 3, 4, 5, 6]; track num) {
    <button
      class="flex h-24 flex-col items-start justify-end rounded-lg border border-zinc-200 bg-zinc-50 p-2 md:h-28 md:p-4 lg:h-32"
      (click)="addSuggestion(num)">
      <p class="text-left text-sm">
        {{ `chat.suggestion.${num}.text` | transloco }}
        <span class="text-stone-300">{{ `chat.suggestion.${num}.hint` | transloco }}</span>
      </p>
    </button>
  }
</div>
